import {
  Button,
  Image,
  logos,
  Spacer,
  Stack,
  TextTitle,
} from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';

export type ProjectCreatedPropsType = {
  closeModal: () => void;
};

export const ProjectCreated = ({ closeModal }: ProjectCreatedPropsType) => {
  return (
    <>
      <Stack justifyContent="center">
        <Image src={logos.project} />
      </Stack>
      <Spacer size="xlarge" />
      <TextTitle
        test-id="project-created-create-project-form-title"
        size="small"
        textAlign="center"
      >
        <TranslationComponent i18nKey="manager/projects:createProject.step5.title">
          Success!
        </TranslationComponent>
      </TextTitle>
      <TextTitle
        test-id="project-created-create-project-form-sub-title"
        size="small"
        textAlign="center"
      >
        <TranslationComponent i18nKey="manager/projects:createProject.step5.subTitle">
          New project has been created...
        </TranslationComponent>
      </TextTitle>
      <Spacer size="xlarge" />
      <Stack justifyContent="end">
        <Button
          test-id="done-button"
          variant="primary"
          size="large"
          type="button"
          onClick={closeModal}
        >
          <TranslationComponent i18nKey="manager/projects:createProject.step5.button">
            Done
          </TranslationComponent>
        </Button>
      </Stack>
    </>
  );
};
